import type { FC } from 'react';
import { useIntl } from 'react-intl';
import { useCurrency } from '../../../contexts/CurrencyContext';
import { formatCurrency } from '../../../utils/currency';
import { Text } from '../../typography';

export interface RegularPriceProps {
    price: number;
    isPriceHeader?: boolean;
    isDrawer?: boolean;
    isCrossed?: boolean;
    id?: string;
}

export const RegularPrice: FC<RegularPriceProps> = ({
    price,
    isPriceHeader,
    isDrawer,
    isCrossed,
    id,
}) => {
    const currency = useCurrency();
    const intl = useIntl();
    const formattedPrice = formatCurrency(price, currency, intl.locale);

    if (isCrossed) {
        return (
            <Text size="small" type="cross" color="slt-pepper.900">
                {formattedPrice}
            </Text>
        );
    }

    if (isPriceHeader && !isDrawer) {
        return (
            <Text id={id} color="slt-pepper.1000" style="bold">
                {formattedPrice}
            </Text>
        );
    }

    return (
        <Text id={id} color="slt-pepper.1000" as="span" style="bold">
            {formattedPrice}
        </Text>
    );
};
